import React from 'react'

import EventPage from '../../Components/EventPage/EventPage'
import EventTexts from '../../Components/EventTexts/EventTexts'

const FailureState: React.FC = () => {
    return (
        <EventPage>
            <EventTexts
                title=""
                message="We're currently unable to show upcoming departure times on this screen."
                description="För tillfället kan vi inte visa avgångstider på denna skärm."
            />
        </EventPage>
    )
}

export default FailureState
